import React, { useEffect, useState } from "react";
import { Overview } from "./Overview/Overview";
import { Listings } from "./Listings/Listings";
import { Property } from "./Property/Property";
import { Contact } from "./Contact/Contact";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { auth } from "./Firebase/Firebase";
import {
  signInAnonymously,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { AdminPanel } from "./AdminPanel/AdminPanel";
import { AdminLogin } from "./AdminLogin/AdminLogin";
import { FichaTecnica } from "./FichaTecnica/FichaTecnica";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const App = () => {
  const [isAdminLoggedIn, setAdminLoggedIn] = useState(false);

  useEffect(() => {
    console.log("Component Mounted");
    if (window.location.pathname !== "/admin") {
      setPersistence(auth, browserLocalPersistence)
        .then(() => {
          return signInAnonymously(auth);
        })
        .then(() => {
          console.log("Signed in anonymously");
        })
        .catch((error) => {
          console.error("Anonymous sign-in failed:", error);
        });

      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          const uid = user.uid;
          console.log("User ID:", uid);
        } else {
          console.log("User is signed out");
        }
      });

      return () => {
        console.log("Component Will Unmount");
        unsubscribe();
      };
    } // Clean up the subscription on unmount
  }, []);

  const handleAdminLoginSuccess = () => {
    setAdminLoggedIn(true);
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Overview />,
      children: [],
    },
    {
      path: "/listings",
      element: <Listings />,
      children: [],
    },
    {
      path: "/property",
      element: <Property />,
      children: [],
    },
    { 
      path: "/contact",
      element: <Contact />,
      children: [],
    },
    {
      path: "/admin",
      element: isAdminLoggedIn ? (
        <AdminPanel />
      ) : (
        <AdminLogin onLoginSuccess={handleAdminLoginSuccess} />
      ),
    },
    {
      path: "/fichaTecnica",
      element: <FichaTecnica />,
    },
  ]);
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};

export default App;
